import { TaskTrackerItemState } from "../../enum/task-tracker-item-state";
import { TaskTrackerItemSubItem } from "./task-tracker-item-sub-item";

/**трэкер: задача */
export class TaskTrackerItem {
    id: number = 0;
    name: string = '';
    subItems: TaskTrackerItemSubItem[] = [];
    mainText: string = '';
    state: TaskTrackerItemState = TaskTrackerItemState.Undef;
    leftBlockWidth: number = 300;
    finalMessageHidden: boolean = false;
}
